/*
 * Module for the Topic Diagram area, which wraps the topic diagram
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicDiagramArea/topicDiagramAreaView",
  "modules/topicsSplit/topic/topicDiagramArea/topicDiagram/topicDiagramModule",
], function (Marionette, TopicDiagramAreaView, TopicDiagramModule) {
  var TopicConversationController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.readOnly = options.readOnly;
      this.name = "topicDiagramArea";
    },
    show: function (conversation) {
      this.layout = new TopicDiagramAreaView.topicDiagramAreaLayout();
      this.diagram = this.addSubModule(
        new TopicDiagramModule({ region: this.layout.diagram, readOnly: this.readOnly }),
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews(conversation);
        },
        this,
      );
      this.showRegion(this.layout, { loading: true, entity: conversation });
    },
    _showSubViews: function (conversation) {
      this.diagram.show(conversation);
    },
  });

  return TopicConversationController;
});
